import React from 'react';
import ReactDOM from 'react-dom';
import Joyride from 'react-joyride';
import Dialog from 'react-bootstrap-dialog';
import Cookies from 'universal-cookie';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/styles";
import { getPageTourParams, GetSectionCustomizationOptions } from 'components/util';
import 'react-joyride/lib/react-joyride-compiled.css';


const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

class SiteTour extends React.Component {    

    constructor(props) {
        super(props);

        this.state = {
            isReady: false,
            isRunning: false,
            scrollToSteps: true,
            steps: getPageTourParams(window.location.pathname, this.props.isAnonymous ? "anonymous" : (this.props.audience ? this.props.audience.type : null)),
            page: window.location.pathname,
            doNotShowWelcomeTour: false,
        };

        this.TourCallback = this.TourCallback.bind(this);
        this.moveToNext = this.moveToNext.bind(this);
        this.hashchange = this.hashchange.bind(this);        
    }

    componentDidMount() {
        //window.addEventListener('popstate', this.hashchange);
        if(this.props.setTourRef) {
            this.props.setTourRef(this);
        }
    }

    componentWillUnmount() {
        //window.removeEventListener('popstate', this.hashchange);
    }

    hashchange(e) {
        //this.setState({
        //    steps: getPageTourParams(window.location.pathname, this.props.audience ? this.props.audience.type : null, this.props.selectedClient),
        //    page: window.location.pathname
        //});
    }

    componentWillReceiveProps(nextProps) {
        if(window.location.pathname !== this.state.page || 
            JSON.stringify(this.props.audience) !== JSON.stringify(nextProps.audience) || 
            JSON.stringify(this.props.selectedClient) !== JSON.stringify(nextProps.selectedClient) || 
            this.props.isAnonymous !== nextProps.isAnonymous){
            this.setState({
                steps: getPageTourParams(window.location.pathname, nextProps.isAnonymous ? "anonymous" : (nextProps.audience ? nextProps.audience.type : null), nextProps.selectedClient),
                page: window.location.pathname
            }, () => {
                const cookies = new Cookies();
                var cVal = cookies.get('HideWelcomeTourMessage');
                if(!cVal){
                    //this.openWelcomeTourDialog();
                }                
            });            
        }
    }

    startTour = () => {
        if(this.joyride){
            window.scrollTo(0, 0);
            this.joyride.reset();

            this.setState({isReady: true, isRunning: false, scrollToSteps: true});

            setTimeout(() => {
                this.setState({isRunning: true},()=>{
                    var joyDiv = ReactDOM.findDOMNode(this.joyride).children[0];
                    if(joyDiv){
                        var rootEle = document.getElementById('root');                        
                        var fullHeight = rootEle.scrollHeight;
                        var existingHeight = joyDiv.style.height.replace('px','');
                        if(rootEle && fullHeight && fullHeight > existingHeight){
                            joyDiv.style.height = fullHeight + 'px';
                        }
                    }
                });
            }, 300);            
        }
    }

    moveToNext(){
        if(this.joyride){
            this.joyride.next();
        }
    }

    TourCallback(data) {
        if(data.action === 'close' || data.type === 'finished') {            
            this.setState({isRunning: false, scrollToSteps: false});
        }
    }

    openWelcomeTourDialog = () => {
        var self = this;
        if(self.dialogWelcomeTour){
            Dialog.setOptions({
                //defaultCancelLabel: "No",
                //defaultOkLabel: "Yes",
            });
            self.dialogWelcomeTour.show({
                body: (
                    <div>
                        <div>{(CommonCustomizationOptions && CommonCustomizationOptions.WelcomeTourMessage && CommonCustomizationOptions.WelcomeTourMessage !== "") ?  CommonCustomizationOptions.WelcomeTourMessage : "Welcome, would you like to take a tour?"}</div>
                        <div style={{margin: "5px 0px 0px 10px"}}>
                            <input type="checkbox" onChange={(e) => {self.setState({doNotShowWelcomeTour: e.target.checked})}} />
                            <span style={{marginLeft: 10, fontSize: 13}}>{(CommonCustomizationOptions && CommonCustomizationOptions.WelcomeTourHideMessage && CommonCustomizationOptions.WelcomeTourHideMessage !== "") ?  CommonCustomizationOptions.WelcomeTourHideMessage : "Do not show this again"}</span>
                        </div>
                    </div>
                    ),
                bsSize: 'small',
                actions: [
                    Dialog.Action(
                        'No',
                        () => {
                            if(self.state.doNotShowWelcomeTour){
                                self.setCookie(self.state.doNotShowWelcomeTour);
                            }
                        },
                        'btn-compact-imp'
                    ),
                    Dialog.Action(
                        'Yes',
                        () => {
                            if(self.state.doNotShowWelcomeTour){
                                self.setCookie(self.state.doNotShowWelcomeTour);
                            }
                            self.startTour();
                        },
                        'btn-compact-imp'
                    )
                ]
            });
        }
    }

    setCookie = (val) => {
        if(val){
            var thirtyDays = new Date();
            thirtyDays.setDate(new Date().getDate()+30);
            const cookies = new Cookies();
            cookies.set('HideWelcomeTourMessage', 'true', { expires: thirtyDays });
        }
    }

    render() {
        const { classes } = this.props;
        return(
            <div>
                <Typography  className={((classes && classes.sitetour) || "") +  " sitetour"} component={'span'} variant="body2">
                {/* showSiteTour(window.location.pathname, this.props.audience ? this.props.audience.type : null) && */
                    <div>
                        {/* <Dialog ref={(el) => { this.dialogWelcomeTour = el }} />
                        <div className="tour_button" onClick={this.startTour}>
                            <img src={light} alt=""/>
                        </div> */}
                        <Joyride
                            ref={j => (this.joyride = j)}
                            callback={this.TourCallback}
                            run={this.state.isRunning}
                            debug={false}
                            showOverlay={true}
                            showSkipButton={true}
                            showStepsProgress={true}
                            steps={this.state.steps}
                            type='continuous'
                            disableOverlay={true}
                            autoStart={true}
                            keyboardNavigation={false}
                            scrollToFirstStep={true}
                            scrollToSteps={this.state.scrollToSteps}
                            scrollOffset={95}
                            locale={
                                {
                                    back: (<span>Back</span>),
                                    close: (<span>Close</span>),
                                    last: (<span>Done</span>),
                                    next: (<span>Next</span>),
                                    skip: (<span>Skip</span>)
                                }
                            }
                        />
                    </div>
                }
                </Typography>
            </div>
        );
    }
}

const styles = theme => ({

    typographytitle: {
        fontWeight:'normal',
        lineHeight:'normal',
        letterSpacing:'inherit',
        color:theme.palette.primary.title,
        '&.MuiTypography-h1': {
            fontWeight:'normal',
            lineHeight:'normal',
            letterSpacing:'inherit',
        },
        '&.MuiTypography-h2': {
            fontWeight:'normal',
            lineHeight:'normal',
            letterSpacing:'inherit',
        } 
    },
    sitetour:{
        '& .joyride-tooltip__header':{
                color:theme.palette.primary.title,
        },
        '& .joyride-tooltip__button':{
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.text,
                minWidth:'inherit',
                fontWeight:'inherit',
                textTransform:'none',
                letterSpacing:'inherit',
            '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.text,
            },
            '&:focus': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.text,
            },
            '&.joyride-tooltip__button--secondary': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    color: theme.palette.secondary.main,
                },
                '&:focus': {
                    color: theme.palette.secondary.main,
                }
            },
        },
    }
});

export default withStyles(styles)(SiteTour);